import { Alert, Card } from "@payezy/ui";
import { useEffect } from "react";
import { Brand } from "../components/Brand";
import { viewAs } from "../lib/api";

/**
 * Entry point for staff view-as sessions opened from the back-office. The token arrives
 * in the URL fragment (never sent to servers or logged) and lives only in this tab.
 */
export function ViewAsStartPage() {
  useEffect(() => {
    const token = new URLSearchParams(window.location.hash.slice(1)).get("token");
    if (token) {
      viewAs.set(token);
      history.replaceState(null, "", "/view-as");
      window.location.replace("/");
    }
  }, []);
  return (
    <div className="flex min-h-dvh items-center justify-center">
      <Brand />
    </div>
  );
}

export function ViewAsEndedPage() {
  return (
    <div className="flex min-h-dvh flex-col items-center justify-center px-4">
      <Brand className="mb-8" />
      <Card className="w-full max-w-sm p-6">
        <Alert tone="info" title="View-as session ended">You can close this tab.</Alert>
      </Card>
    </div>
  );
}
